<ng-container *ngFor="let item of text">
  <ng-container *ngIf="item | typeofCheck: 'string'; else link">{{
    item
  }}</ng-container>

  <ng-template #link
    ><nx-link
      ><a [href]="item.link | translate" [target]="item.target || '_blank'">{{
        item.text | translate
      }}</a></nx-link
    ></ng-template
  >
</ng-container>
